import type React from 'react';

import { SocialSharing, SocialSharingGroup, Text } from '@change/ds-core-ui';
import type { Icon } from '@change/ds-icons';
import { EmailIcon, FacebookIcon, ShareNowIcon, TwitterIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import type { Channel } from './hooks/useShareLinks';
import { useShareLinks } from './hooks/useShareLinks';

const ICON_MAP: Record<Channel, React.FC<Icon>> = {
	twitter: TwitterIcon,
	facebook: FacebookIcon,
	email: EmailIcon,
};

const VARIANT_MAP: Record<Channel, 'twitter' | 'facebook' | 'default'> = {
	twitter: 'twitter',
	facebook: 'facebook',
	email: 'default',
};

export const ShareLinks: React.FC = () => {
	const {
		data: { shareActions },
	} = useShareLinks();

	return (
		<div className="flex items-center gap-4">
			<Text className="text-typography-weak hidden uppercase md:block" size="small">
				<Translate value="fe.components.news_header.share" />
			</Text>
			<Text className="text-typography-weak flex items-center uppercase md:hidden" size="small">
				<Text className="sr-only" size="small">
					<Translate value="fe.components.news_header.share" />
				</Text>
				<ShareNowIcon size="medium" />
			</Text>

			<SocialSharingGroup layout="inline" className="gap-4">
				{shareActions.map(({ channel, ShareAction }) => {
					const IconComponent = ICON_MAP[channel];
					return (
						<ShareAction key={channel}>
							{/* TODO aria-label should be a i18n string, at least for email */}
							<SocialSharing
								data-testid={`news-share-${channel}`}
								data-qa={`news-share-${channel}`}
								aria-label={channel}
								icon={<IconComponent />}
								label=""
								variant={VARIANT_MAP[channel]}
								size="medium"
								className="w-8"
							/>
						</ShareAction>
					);
				})}
			</SocialSharingGroup>
		</div>
	);
};
